import type {BusinessState} from './types';

const defaultState: BusinessState = {
  claimPlace: {
    place: null,
    loading: false,
    errorMessage: null,
  },
  previewPlace: {
    loading: true,
    place: null,
  },
  myPlaces: {
    items: [],
    total: 0,
    loading: true,
  },
  code: null,
  phone: null,
  editPlace: {
    place: null,
    loading: true,
    error: false,
  },
  placeToSubmit: {},
};

export {defaultState};
